export default __webpack_public_path__ + "static/media/MDS.c4053c85.png";